import _ from 'lodash';
import ProjectCtrl from '../project/home/project.controller';
import project from '../project/home/project.component';
import ProjectListCtrl from '../project/list/project-list.controller';
import projectListTemplate from '../project/list/list.html';
import UserResolver from '../authentication/user-resolver';
import { useNewDesign } from './design-refresh';

const ProjectsRouter = {
  route: (module) => {
    module
      .component('project', project)
      .controller('ProjectCtrl', ProjectCtrl)
      .controller('ProjectListCtrl', ProjectListCtrl);

    module.config(['$stateProvider', ($stateProvider) => {
      $stateProvider
        .state('projects', {
          url: '/projects',
          controller: ['$state', '$scope', function ($state, $scope) { $scope.$state = $state; }],
          abstract: true,
          parent: 'root',
          template: '<div ui-view="projects-index" ng-show="$state.includes(\'project\')"></div><div ui-view="projects-show" ng-show="$state.includes(\'singleproject\')" ></div>',
        })
        .state('project', {
          url: '?testType&tab&country',
          parent: 'projects',
          reloadOnSearch: false, // this means: reloadOnQueryParamChange
          views: {
            'projects-index': {
              template: `
                <ut-projects-page ng-if="$resolve.useNewDesign" [user]="$resolve.user" [header-data]="$resolve.headerData.data" [project-info]="$resolve.projectInfo"></ut-projects-page>
                <project ng-if="!$resolve.useNewDesign" $transition$="::$resolve.$transition$" user="::$resolve.user" cover-bg="::$resolve.coverBg" header-data="::$resolve.headerData" project-info="::$resolve.projectInfo"></project>
              `,
            },
          },
          sticky: true,
          resolve: {
            headerData: ['StaticValuesService', (StaticValuesService) => {
              const unauthDescriptionText = 'Whether you’re an everyday technology user or a subject-matter expert, you can start improving digital products as a paid tester with uTest. Browse opportunities below and sign up to receive even more in your inbox.';
              const defaultData = {
                title: 'Projects Board',
                description: 'Please know, the Projects Board shows only a small fraction of the paid project opportunities uTest has to offer! Increase your chances at being matched with paid project opportunities by keeping your Tester Profile complete and up-to-date! <br> <br>\n'
                + '        We need your help! The projects listed below are ones which we were unable to automatically identify testers for due to unique requirements. Read through the project details carefully and apply for any project you are a match for!',
                unauthDescription: unauthDescriptionText,
                coverBg: {
                  small: '/utest-static/assets/images/hero/projects-bg-xs.jpg',
                  large: '/utest-static/assets/images/hero/projects-bg.jpg',
                },
                unauthCoverBg: {
                  wide: '/utest-static/assets/images/hero/unauth-background.svg',
                  medium: '/utest-static/assets/images/hero/unauth-background-s.svg',
                  small: '/utest-static/assets/images/hero/unauth-background-xs.svg',
                },
              };
              return StaticValuesService.pageData('projects').then((response) => {
                response.data = _.defaultsDeep(response.data, defaultData);
                return response;
              }, _error => ({
                data: defaultData,
              }));
            }],
            coverBg: ['ImageDataService', 'headerData', (ImageDataService, headerData) => (headerData.data.coverBg.small === '/utest-static/assets/images/hero/projects-bg-xs.jpg'
              ? ImageDataService.getData(headerData.data.coverBg.small) : headerData.data.coverBg.small)],
            user: UserResolver,
            projectInfo: ['ProjectService', (ProjectService) => ProjectService.info().then(({ data }) => data)],
            title: [() => 'uTest Projects'],
            useNewDesign,
          },
        })
        .state('singleproject', {
          url: '/:projectId',
          parent: 'projects',
          views: {
            'projects-show': {
              template: `
                <ut-project-page ng-if="$resolve.useNewDesign" [project]="$resolve.project.data" [user]="$resolve.user"></ut-project-page>
                <single-project ng-if="!$resolve.useNewDesign" project="::$resolve.project" user="::$resolve.user"></single-project>
              `,
            },
          },
          resolve: {
            project: ['ProjectService', '$transition$', '$state', function (ProjectService, $transition$, $state) {
              const newPromise = ProjectService.find($transition$.params().projectId);
              newPromise.catch(() => $state.go('project'));
              return newPromise;
            }],
            title: ['project', project => `uTest Project - ${project.data.title}`],
            meta: ['project', 'title', 'Meta', function (project, title, Meta) {
              Meta.updateTag({ name: 'og:title', property: 'og:title', content: `${title} - via @uTest` });
            }],
            user: UserResolver,
            useNewDesign,
          },
        })
        .state('projectlist', {
          url: '/projects/t/:tags',
          template: `
            <ut-project-list-page ng-if="$resolve.useNewDesign" [projects]="$resolve.projects" [tags]="$resolve.$transition$.params().tags"></ut-project-list-page>
            <div ng-if="!$resolve.useNewDesign">${projectListTemplate}</div>
          `,
          controller: 'ProjectListCtrl',
          parent: 'root',
          resolve: {
            projects: ['$transition$', 'ProjectService', 'FeedStore', function ($transition$, ProjectService, FeedStore) {
              return FeedStore.create(_.bind(ProjectService.feed, ProjectService), { sort: '-published_at', filter: { state: 'published', tags: $transition$.params().tags.split('+') } }).load();
            }],
            title: [() => 'uTest Projects'],
            useNewDesign,
          },
        });
    }]);
  },
};

export default ProjectsRouter;
